import React, { createRef, useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import "./license.css";

/**
 * ツールチップElement
 */
const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#ffffff",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 550,
    fontSize: theme.typography.pxToRem(15),
    border: "1px solid #000000",
  },
}));

export interface IProps {
  /**
   * メモ文字列
   */
  text: string;
}

/**
 * メモテキストElement
 * @param props - メモテキストパラメータ
 * @returns メモテキストElement
 */
export default function MemoText(props: IProps) {
  const refDiv = createRef<HTMLDivElement>();
  const refSpan = createRef<HTMLSpanElement>();
  const [tooltipEnabled, setTooltipEnabled] = useState<boolean>(false);
  const [open, setOpen] = useState(false);
  
  useEffect(() => {
    if (refSpan.current && refDiv.current) {
      const rectSpan = refSpan.current.getBoundingClientRect();
      const rectDiv = refDiv.current.getBoundingClientRect();
      setTooltipEnabled(rectDiv.width < rectSpan.width);
    }
  }, []);

  function handleMouseOver() {
    if (open === false) {
      setOpen(true);
    }
  }
  function handleMouseLeave() {
    if (open === true) {
      setOpen(false);
    }
  }

  return (
    <div className="memo-text" ref={refDiv}>
      <CustomTooltip
        title={tooltipEnabled ? props.text : ""}
        placement="bottom-start"
        open={open}
      >
        <span
          ref={refSpan}
          onMouseOver={handleMouseOver}
          onMouseLeave={handleMouseLeave}
        >
          {props.text}
        </span>
      </CustomTooltip>
    </div>
  );
}
